import router from "../src/router/index";
import path from "./url";
import store from "../store/index";
import $http from "./http";
const utils = {
  passwordRegex:/^(?!.*(.)\1\1)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{12,}$/,
  getUrlParam(name) {
    // 获取地址栏参数
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
  checkPhone(phone) {
    const pattern = /0?(13|14|15|18|17)[0-9]{9}/;
    return pattern.test(phone);
  },
  checkCardNo(cardNo) {
    const pattern = /^\d{16}|\d{19}$/;
    return pattern.test(cardNo);
  },
  checkEmail(email) {
    const pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return pattern.test(email);
  },
  formatDate(fmt, time) {
    // 格式化时间
    let ret;
    let date = time && typeof time == "object" ? time : new Date(time || "");
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
        );
      }
    }
    return fmt;
  },
  async login(params1,params2) {
    // console.log(params1)
    // console.log(params2)
    if(params1 && params2){
      // 账号密码登陆
      const userInfo =  await this.loginByAccount(params1,params2)
      return userInfo
    }else{
      // 通过openId 登录
      const userInfo =  await this.loginByOpenId(params1)
      return userInfo
    }
  },
  async loginByAccount(userName,pwd){
    if(!userName || !userName.length || !pwd || !pwd.length) return null
    let userInfo = store.state.userInfo;
    if (!userInfo || !userInfo.id) {
      // 未登录
      userInfo = await store.dispatch("getUserInfoByAccount", {
        userName: userName,
        pwd:pwd
      });
      console.log(userInfo)
      // if (!userInfo.id) return null;
      return userInfo;
    }
    return userInfo;
  },
  async loginByOpenId(openId) {
    // 通过openId 登录
    openId = openId || this.getUrlParam("openId") || store.state.openId;
    if (!openId) return null;
    let userInfo = store.state.userInfo;
    if (!userInfo || !userInfo.id) {
      // 未登录
      userInfo = await store.dispatch("getUserInfo", {
        openId: openId
      });
      if (!userInfo.id) return null;
      return userInfo;
    }
    return userInfo;
  },
  async logout() {
    var state
    state = await store.dispatch("removeUserInfo");
    console.log('state:' + state)
    return state
  },
};
export default utils;



//////////////////
// WEBPACK FOOTER
// ./api/utils.js
// module id = null
// module chunks = 